import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttovadodaracab() {



  const cardData =
  {
    keyword: 'Mumbai Airport to Vadodara Cab',
    heading: 'Shambhu Cabs: Mumbai Airport to Vadodara Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai Airport to Vadodara Cab services, providing safe, comfortable, and hassle-free travel for families, corporate travelers, business professionals, and tourists. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient journey from Mumbai Airport to Vadodara with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup from all terminals at Chhatrapati Shivaji Maharaj International Airport, and 24/7 booking support, Shambhu Cabs makes intercity travel stress-free and dependable. For comfort, safety, and a trusted Mumbai Airport to Vadodara cab experience, Shambhu Cabs is your reliable travel partner.',

    top: 'Top Places to Visit in Vadodara with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Laxmi Vilas Palace",
    "description": "Laxmi Vilas Palace, built in 1890 by Maharaja Sayajirao Gaekwad III, is one of the grandest private residences in India. Spread over 700 acres, the palace showcases Indo-Saracenic architecture, ornate interiors, and extensive gardens. It houses an impressive collection of armory, sculptures, and paintings. Visitors can explore the museum, the Durbar Hall, and the palace grounds, making it a landmark reflecting Vadodara’s royal heritage."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug is Vadodara’s largest and most popular garden, covering over 50 hectares. It features a zoo, planetarium, toy train, fountains, walking paths, and lush greenery. The garden is ideal for family outings, morning walks, and recreational activities. Its cultural significance and serene environment make it a must-visit destination in Vadodara."
  },
  {
    "title": "Baroda Museum & Picture Gallery",
    "description": "Located within Sayaji Baug, the Baroda Museum & Picture Gallery showcases artifacts from Indian, Asian, and European origins. Visitors can admire sculptures, paintings, textiles, coins, and archaeological exhibits. The museum offers educational tours, cultural insight, and an opportunity to explore Vadodara’s rich historical and artistic heritage."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir is a memorial dedicated to the Gaekwad dynasty, built in white marble with intricate carvings and murals depicting the royal family’s history. It serves as both a heritage monument and a spiritual site, attracting tourists and devotees alike. The serene surroundings and architectural elegance make it a significant cultural landmark in Vadodara."
  },
  {
    "title": "EME Temple",
    "description": "The EME Temple, also called the Dakshinamurthy Temple, is a unique military-style temple in Vadodara, maintained by the Indian Army. Its architecture blends modern and traditional styles, with a serene meditation hall and spiritual ambiance. The temple is dedicated to Lord Dakshinamurthy and attracts devotees, visitors, and architecture enthusiasts seeking a peaceful retreat."
  },
  {
    "title": "Sayaji Baug Zoo",
    "description": "Located within Sayaji Baug, the zoo is home to a wide variety of animals including tigers, lions, reptiles, and birds. It is well-maintained and ideal for family visits, wildlife education, and photography. The zoo, combined with the garden, offers a complete recreational experience in the heart of Vadodara."
  },
  {
    "title": "Sardar Patel Planetarium",
    "description": "The Sardar Patel Planetarium in Sayaji Baug is a major attraction for science enthusiasts and students. It offers shows on astronomy, space, and science, using modern projection systems. The planetarium promotes education and curiosity while providing an entertaining experience for visitors of all ages."
  },
  {
    "title": "Nazarbaug Palace",
    "description": "Nazarbaug Palace is a historical palace associated with the Gaekwad dynasty. Though partially in ruins, it holds architectural and historical significance. Visitors can explore the palace area, learn about Vadodara’s royal past, and admire remnants of royal artifacts and gardens. It is a key landmark reflecting the city’s heritage."
  },
  {
    "title": "Sur Sagar Lake",
    "description": "Sur Sagar Lake is a serene waterbody in the heart of Vadodara, featuring a statue of Lord Krishna in its center. The lake is surrounded by walking paths, gardens, and peaceful seating areas. It is a popular spot for morning and evening walks, photography, and enjoying quiet moments in the midst of the bustling city."
  },
  {
    "title": "Maharaja Fateh Singh Museum",
    "description": "Housed in the Lakshmi Vilas Palace complex, the Maharaja Fateh Singh Museum displays royal artifacts, sculptures, miniature paintings, and decorative arts. The museum offers insight into Vadodara’s royal history and art heritage, making it an essential stop for culture and history enthusiasts visiting the city."
  }
],




"services": [
  {
    "name": "Mumbai Airport Vadodara Taxi",
    "description": "Mumbai Airport Vadodara Taxi provides reliable and comfortable travel from Mumbai Airport (T2) to Vadodara. Passengers can enjoy well-maintained vehicles, professional drivers, and a stress-free journey with timely pickups and drop-offs."
  },
  {
    "name": "Vadodara from Mumbai Airport Cab",
    "description": "Vadodara from Mumbai Airport Cab offers a seamless connection from Mumbai Airport to Vadodara with comfortable sedans and SUVs. Perfect for both leisure and business travelers looking for a smooth airport transfer."
  },
  {
    "name": "One Way Airport Cab Mumbai to Vadodara",
    "description": "One Way Airport Cab Mumbai to Vadodara is ideal for travelers seeking a single-direction airport transfer. With competitive fares and punctual service, it ensures a safe and comfortable ride."
  },
  {
    "name": "Baroda Taxi from Mumbai Airport",
    "description": "Baroda Taxi from Mumbai Airport provides direct travel from the airport to Vadodara with professional drivers, clean vehicles, and convenient online booking options for stress-free travel."
  },
  {
    "name": "Affordable Airport Taxi Mumbai Vadodara",
    "description": "Affordable Airport Taxi Mumbai Vadodara offers cost-effective yet comfortable travel options. Passengers can choose from AC sedans and SUVs without compromising on safety or service quality."
  },
  {
    "name": "SUV Cab Mumbai Vadodara",
    "description": "SUV Cab Mumbai Vadodara is designed for families or groups with extra luggage. Spacious and comfortable, these vehicles ensure a smooth long-distance journey from Mumbai Airport to Vadodara."
  },
  {
    "name": "Sedan Cab Mumbai Vadodara",
    "description": "Sedan Cab Mumbai Vadodara provides an economical and comfortable travel option for small families or solo travelers. Air-conditioned sedans like Dzire and Etios offer a pleasant ride to Vadodara."
  },
  {
    "name": "Airport Pickup Mumbai Vadodara Cab",
    "description": "Airport Pickup Mumbai Vadodara Cab ensures timely pickup from Mumbai Airport with courteous drivers and well-maintained vehicles. Ideal for business travelers and tourists alike."
  },
  {
    "name": "Long Distance Taxi Mumbai Airport",
    "description": "Long Distance Taxi Mumbai Airport specializes in airport transfers to Vadodara with optimized routes and comfortable vehicles, ensuring a smooth and punctual long-distance travel experience."
  },
  {
    "name": "Premium Taxi Mumbai Airport to Vadodara",
    "description": "Premium Taxi Mumbai Airport to Vadodara offers luxury sedans and high-end SUVs for passengers who seek extra comfort and style during airport transfers."
  },
  {
    "name": "24x7 Cab Mumbai Airport Vadodara",
    "description": "24x7 Cab Mumbai Airport Vadodara ensures round-the-clock availability for early morning or late-night flights, providing flexible and reliable service anytime."
  },
  {
    "name": "Safe Airport Taxi Mumbai",
    "description": "Safe Airport Taxi Mumbai focuses on passenger safety with trained drivers, well-maintained vehicles, and adherence to traffic rules for a secure journey from Mumbai Airport to Vadodara."
  },
  {
    "name": "Corporate Cab Mumbai Vadodara",
    "description": "Corporate Cab Mumbai Vadodara provides premium transport for business travelers. AC sedans and SUVs, professional drivers, and timely service make it ideal for office trips or client meetings."
  },
  {
    "name": "Fast Cab Mumbai Airport",
    "description": "Fast Cab Mumbai Airport ensures quick and efficient airport transfers to Vadodara with optimized routes and prompt drivers, ideal for travelers with tight schedules."
  }
],

"tableData": [
  ["Mumbai Airport Vadodara Taxi", "Vadodara from Mumbai Airport Cab"],
  ["One Way Airport Cab Mumbai to Vadodara", "Baroda Taxi from Mumbai Airport"],
  ["Affordable Airport Taxi Mumbai Vadodara", "SUV Cab Mumbai Vadodara"],
  ["Sedan Cab Mumbai Vadodara", "Airport Pickup Mumbai Vadodara Cab"],
  ["Long Distance Taxi Mumbai Airport", "Premium Taxi Mumbai Airport to Vadodara"],
  ["24x7 Cab Mumbai Airport Vadodara", "Safe Airport Taxi Mumbai"],
  ["Corporate Cab Mumbai Vadodara", "Fast Cab Mumbai Airport"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai Airport to Vadodara Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable cab services from Mumbai Airport to Vadodara, ideal for business trips, family travel, and comfortable long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and comfortable ride from Mumbai Airport to Vadodara."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai Airport to Vadodara route, ensuring safe driving, timely arrivals, and a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Mumbai Airport to Vadodara cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans tailored to your journey from Mumbai Airport to Vadodara."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai Airport to Vadodara journey smooth, comfortable, and worry-free."
  }
]






























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai Airport to Vadodara?',
    answer: 'Yes, Shambhu Cabs offers convenient and reliable cab services from Mumbai Airport to Vadodara, ensuring a comfortable and timely journey for you.',
  },
  {
    question: 'How can I book a cab from Mumbai Airport to Vadodara?',
    answer: 'You can easily book a cab from Mumbai Airport to Vadodara through our website, mobile app, or by contacting our 24x7 customer support team for hassle-free bookings.',
  },
  {
    question: 'What types of vehicles are available for Mumbai Airport to Vadodara cab bookings?',
    answer: 'Shambhu Cabs offers a range of vehicles for your Mumbai Airport to Vadodara journey, including sedans, SUVs, luxury cars, and larger vehicles for group travel.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai Airport to Vadodara journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the route from Mumbai Airport to Vadodara, ensuring a smooth, safe, and comfortable ride.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai Airport to Vadodara trip?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points at Mumbai Airport and Vadodara, offering you flexibility and convenience for your journey.',
  },
  {
    question: 'Is the Mumbai Airport to Vadodara cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 cab services for your journey from Mumbai Airport to Vadodara, so you can travel at any time based on your convenience.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai Airport to Vadodara trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure your safety and well-being during the journey.',
  },
  {
    question: 'What payment options are available for Mumbai Airport to Vadodara cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all Mumbai Airport to Vadodara cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai Airport to Vadodara trip?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you throughout your journey from Mumbai Airport to Vadodara.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harsh Patel',
    feedback: 'I traveled from Mumbai Airport to Vadodara with Shambhu Cabs, and the experience was excellent. The driver was professional, and the car was clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rhea Deshmukh',
    feedback: 'Shambhu Cabs made my journey from Mumbai Airport to Vadodara seamless and enjoyable. Great service, on-time pickup, and comfortable ride. Highly recommended!',
    rating: 5,
  },
];














































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const airportVadodaraCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai Airport to Vadodara Cab",
  "serviceType": "Airport Pickup / Outstation Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-airport-to-vadodara-cab.jpg",
  "description": "Shambhu Cabs provides Mumbai Airport to Vadodara cab services. Book affordable SUV and sedan cabs for one-way, corporate, or premium travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "720",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-airport-to-vadodara-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai Airport, Vadodara, India" }
};





  return (
    <div>
<Helmet>
  <title>Mumbai Airport to Vadodara Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai Airport to Vadodara cab with Shambhu Cabs. Affordable SUV and sedan cabs for one-way, corporate, or premium travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Airport Vadodara Taxi, Vadodara from Mumbai Airport Cab, One Way Airport Cab Mumbai to Vadodara, Baroda Taxi from Mumbai Airport, Affordable Airport Taxi Mumbai Vadodara, SUV Cab Mumbai Vadodara, Sedan Cab Mumbai Vadodara, Airport Pickup Mumbai Vadodara Cab, Long Distance Taxi Mumbai Airport, Premium Taxi Mumbai Airport to Vadodara, 24x7 Cab Mumbai Airport Vadodara, Safe Airport Taxi Mumbai, Corporate Cab Mumbai Vadodara, Fast Cab Mumbai Airport"
  />

  <script type="application/ld+json">
    {JSON.stringify(airportVadodaraCabSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttovadodaracab;